// extracted by mini-css-extract-plugin
export var notificationHost = "_im-0";